import { EffectObject, EffectsMap } from 'use-effect-reducer';
import { PostEditorGroupDataActions, SetErrorToastAction } from './PostEditorGroupDataActions';
import { Dispatch } from 'react';
import { PostEditorGroupDataType } from './PostEditorGroupDataProvider';
import { showToast } from '../../../helpers/showToast';
import { getCaptionsEffect, initiateCaptionsEffect, stopCaptionsEffect } from './effects/aiCaptionWritter.effect';

export type TabsEffectArgs = (
  state: PostEditorGroupDataType,
  effect: TabIndexEffectsType,
  dispatch: Dispatch<PostEditorGroupDataActions>
) => void;
export type TabIndexEffectsType = EffectObject<PostEditorGroupDataType, PostEditorGroupDataActions>;

const showErrorToastEffect: TabsEffectArgs = (_, effect) => {
  const error: SetErrorToastAction['payload'] = effect.payload;
  showToast({
    severity: 'error',
    summary: 'Ai Assistant Error',
    detail: error
  });
};

export const PostEditorGroupDataEffects: EffectsMap<
  PostEditorGroupDataType,
  PostEditorGroupDataActions,
  TabIndexEffectsType
> = {
  getCaptionsEffect,
  initiateCaptionsEffect,
  showErrorToastEffect,
  stopCaptionsEffect
};
